import { useState } from 'react'

let cnt = 0;

export const status = {
    error: 1,
    working: 2,
    waiting: 3,
    complete: 4,
};

export default function useNotificationStore() {
    const [_notifications, setNotifications] = useState({});

    function hasNotifications() {
        return Object.keys(_notifications).length;
    }

    function notifications() {
        return Object.values(_notifications);
    }

    function add(title, status, details, percent) {
        const handle = '' + cnt++;
        const read = false;
        setNotifications(prevValues => {
            prevValues[handle] = { title, status, details, percent, read }
            return { ...prevValues }
        })
        return handle;
    }

    function remove(handle) {
        setNotifications(prevValues => {
            delete prevValues[handle]
            return { ...prevValues }
        })
    }

    function update(handle, _update) {
        setNotifications(prevValues => {
            prevValues[handle] = Object.assign({}, prevValues[handle], _update);
            return { ...prevValues }
        })
    }

    function cleanup() {
        setNotifications(prevValues => {
            const to_remove = Object.entries(prevValues).filter(([id, n]) => n.status === status.complete);
            for (let [id] of to_remove) {
                delete prevValues[id]
            }
            return { ...prevValues }
        })
    }

    function markRead() {
        setNotifications(prevValues => {
            for (let [id] of Object.entries(prevValues)) {
                prevValues[id] = Object.assign({}, prevValues[id], {read: true});
            }
            return { ...prevValues }
        })
    }

    function clear() {
        setNotifications(prevValues => {
            for (let [id] of Object.entries(prevValues)) {
                delete prevValues[id]
            }
            return { ...prevValues }
        })
    }

    function unread() {
        let unread = 0;
        for (let [id] of Object.entries(_notifications)) {
            if (!_notifications[id].read) {
                unread++;
            }
        }
        return unread;
    }


    return {
        notifications: notifications,
        hasNotifications: hasNotifications,
        add: add,
        remove: remove,
        update: update,
        cleanup: cleanup,
        markRead: markRead,
        unread: unread,
        clear: clear
    }
}
